.popoverContent {
  align-items: center;
  background: var(--global-color-gray-800);
  border: none;
  border-radius: var(--border-radius-sm);
  display: flex;
  flex-direction: row;
  z-index: 10000;
}

.arrow {
  fill: var(--global-color-gray-800);
}

.tooltipButton {
  background: var(--global-color-gray-800);
  border: none;
  border-radius: var(--border-radius-sm);
  color: var(--color-text-inverted);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  padding: 8px 12px;
  width: 90px;
}

.tooltipText {
  background: var(--global-color-gray-800);
  border-radius: var(--border-radius-sm) 0 0 var(--border-radius-sm);
  border-right: 1px solid var(--global-color-gray-400);
  color: var(--color-text-inverted);
  cursor: default;
  display: inline-block;
  font-size: 14px;
  line-height: 16px;
  max-width: 260px;
  overflow: hidden;
  padding: 8px 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}
